import { render, staticRenderFns } from "./ProductDetailRedesignSkeleton.vue?vue&type=template&id=70e73d0c&"
import script from "./ProductDetailRedesignSkeleton.vue?vue&type=script&lang=js&"
export * from "./ProductDetailRedesignSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetailRedesignSkeleton.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports